import { render, staticRenderFns } from "./component-download.vue?vue&type=template&id=567abe90&scoped=true&"
import script from "./component-download.vue?vue&type=script&lang=js&"
export * from "./component-download.vue?vue&type=script&lang=js&"
import style0 from "./component-download.vue?vue&type=style&index=0&id=567abe90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567abe90",
  null
  
)

export default component.exports